import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const RedirectService = () => {
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        if (location.pathname === '/services') {
            navigate('/services/services-koha');
        }
    }, [location, navigate]);

    return null;
};

export default RedirectService;
